/**
 * 최저임금 검증 유틸리티
 */

// 최저임금: 시간당 10,320원
export const MINIMUM_WAGE_2025 = 10320;

/**
 * 최저임금 확인
 * @param hourlyRate 시급
 * @returns 최저임금 이상이면 true
 */
export function validateMinimumWage(hourlyRate: number): boolean {
  return hourlyRate >= MINIMUM_WAGE_2025;
}

/**
 * 최저임금 미만 시 경고 메시지 반환
 * @param hourlyRate 시급
 * @returns 경고 메시지 또는 null
 */
export function getMinimumWageWarning(hourlyRate: number): string | null {
  if (hourlyRate < MINIMUM_WAGE_2025) {
    return `최저임금(${MINIMUM_WAGE_2025.toLocaleString('ko-KR')}) 미만입니다.`;
  }
  return null;
}

/**
 * 최저임금 포맷팅된 문자열 반환
 * @returns 최저임금 문자열 (예: "10,890원")
 */
export function getMinimumWageFormatted(): string {
  return `${MINIMUM_WAGE_2025.toLocaleString('ko-KR')}`;
}

